import styled from "styled-components";
import SbAvatar from "uiCore/SbAvatar/SbAvatar";
import SbCard from "uiCore/SbCard/SbCard";
import SbSelect from "uiCore/SbSelect/SbSelect";

export const PageWrapperStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 40px;
  min-height: 100%;
  background: ${({ theme }) => theme.colors.light};
`;

// Legal-entity initials avatar — colour cycles per index from the brand palette.
// Mirrors FunctionAvatarStyled in orgContextStyles.js.
export const EntityAvatarStyled = styled(SbAvatar)`
  && {
    background-color: ${p => {
      const palette = [
        p.theme?.colors?.primary,
        p.theme?.colors?.info,
        p.theme?.colors?.statusProcessing,
        p.theme?.colors?.success,
        p.theme?.colors?.danger,
        p.theme?.colors?.gray,
        p.theme?.colors?.dark,
        p.theme?.colors?.tertiary,
      ];
      return palette[p.$index % palette.length] ?? p.theme?.colors?.primary;
    }};
    flex-shrink: 0;
  }
`;

// Brand-teal square icon wrapper for stat tiles (matches AdminSetup CardIconWrapperStyled).
export const StatIconStyled = styled.div`
  width: 38px;
  height: 38px;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
`;

export const BodyCardStyled = styled(SbCard)`
  && {
    border: 1px solid ${({ theme }) => theme.colors.borderLight};
    box-shadow: none;
  }
  .ant-card-body {
    padding: 18px;
  }
`;

// Apartment icon before the BU title — brand-primary teal.
export const BuIconStyled = styled.span`
  color: ${({ theme }) => theme.colors.primary};
  display: inline-flex;
`;

// Small primary-coloured dot rendered before each function name.
export const FnDotStyled = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  display: inline-block;
  flex-shrink: 0;
`;

// Sub-function tag row — pure layout (tag colour comes from <SbTag color={...}/> props).
export const TagsWrapStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
`;

// Width-constrained add-option input with brand-coloured "+" suffix.
export const OptionInputWrapStyled = styled.div`
  min-width: 220px;
  max-width: 320px;
  margin-top: 10px;
`;

// Full-width SbSelect for the legal-entity location dropdown — fills the
// parent SbCol so it lines up with the name input next to it.
export const FullWidthSelectStyled = styled(SbSelect)`
  &&,
  && .ant-select {
    width: 100%;
  }
`;
